import React, { PureComponent } from 'react'
import Checkbox from '../../../../Shared/Form/Checkbox'
import './styles.scss'
import { getRoomName } from '../common'
import Alert from '../../../../Shared/Alert'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { addRoomToImageRelation, deleteRoomToImageRelation } from '../../../../../api'
import Loader from '../../../../Shared/Loader'
import activityTrackingService from '../../../../../services/activityTrackingService'
import { trackingEvent } from '../../../../../constants'

class ImageRoomAssigner extends PureComponent {

  abortController = null
  state = {
    loading: false,
    error: null
  }

  componentWillUnmount () {
    if (this.abortController !== null) {
      this.abortController.abort()
    }
  }

  onChange (desiredChecked, room) {
    if (desiredChecked) {
      activityTrackingService.trackEvent(trackingEvent.assignImageToRoom)
      this.addRoomToImageRelation(room)
    } else {
      this.deleteRoomToImageRelation(room)
    }
  }

  addRoomToImageRelation (room) {
    if (this.abortController !== null) {
      this.abortController.abort()
    }
    this.abortController = new AbortController()

    this.setState({ loading: true, error: null }, () => {
      const { fetchPromise } = addRoomToImageRelation(
        this.props.image.giataId,
        this.props.image.id, room.id,
        this.abortController
      )
      fetchPromise.then(() => {
        this.setState({ loading: false, error: null })
        const newImage = { ...this.props.image }
        newImage.rooms = [...this.props.image.rooms]
        newImage.rooms.push(room.id)
        this.props.onImageChanged(newImage)
      }).catch((e) => {
        console.error(e)
        this.setState({ loading: false, error: true })
      })
    })
  }

  deleteRoomToImageRelation (room) {
    if (this.abortController !== null) {
      this.abortController.abort()
    }
    this.abortController = new AbortController()

    this.setState({ loading: true, error: null }, () => {
      const { fetchPromise } = deleteRoomToImageRelation(
        this.props.image.giataId,
        this.props.image.id,
        room.id,
        this.abortController
      )
      fetchPromise.then(() => {
        this.setState({ loading: false, error: null })
        const newImage = { ...this.props.image }
        newImage.rooms = [...this.props.image.rooms]
        const roomIndex = newImage.rooms.findIndex((r) => r === room.id)
        if (roomIndex > -1) {
          newImage.rooms.splice(roomIndex, 1)
        }
        this.props.onImageChanged(newImage)
      }).catch((e) => {
        console.error(e)
        this.setState({ loading: false, error: true })
      })
    })
  }

  render () {
    const { t } = this.props

    let assignedRoomsMap = {}
    for (let i = 0; i < this.props.image.rooms.length; i++) {
      assignedRoomsMap[this.props.image.rooms[i]] = 1
    }

    return (
      <div className={'image-room-assigner'}>
        <h3>{t('ASSIGN_IMAGE_TO_ROOM')}</h3>
        {this.state.loading && <Loader size={32}/>}
        <div className={'image-to-room-container'}>
          {
            this.props.rooms.length === 0 &&
            <Alert type={'info'}>{t('NO_ROOMS_FOUND')}</Alert>
          }
          {this.state.error && <Alert type={'danger'}>Error occurred</Alert>}
          {this.props.rooms.map((room) => {
            return (
              <div className={'image-to-room'} key={room.id}>
                <div className={'image-to-room-prepend'}>
                  <Checkbox value={assignedRoomsMap.hasOwnProperty(room.id)}
                            onChange={(e) => this.onChange(e.target.checked, room)}/>
                </div>
                <div className={'image-to-room-label'}>
                  <span>{getRoomName(this.props.roomAttributes, room)}</span>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}

ImageRoomAssigner.propTypes = {
  image: PropTypes.object.isRequired,
  roomAttributes: PropTypes.object.isRequired,
  rooms: PropTypes.array.isRequired,
  onImageChanged: PropTypes.func.isRequired
}

export default withTranslation()(ImageRoomAssigner)
